import { FORM_IS_TOUCHED, FORM_IS_UNTOUCHED, SET_EXPANDED_CARD_INDEX, SUBMIT_IS_FAILED } from './constants';

export function unTouchForm() {
  return {
    type: FORM_IS_UNTOUCHED,
  };
}

export function touchForm() {
  return {
    type: FORM_IS_TOUCHED,
  };
}

export function submitHasFailed() {
  return {
    type: SUBMIT_IS_FAILED,
  };
}

export const setExpandedCardIndex = (index: number) => {
  return {
    type: SET_EXPANDED_CARD_INDEX,
    index,
  };
};
